<template>
  <div class="awards-page">
    <header>
      <img src="assets/logo.png" id="logo" />
      <div id="guide">
        <a href="https://moseeker.com">公司首页</a>
        <router-link :to="'/'">势能大会</router-link>
        <router-link :to="'awards'" class="active">势能大奖</router-link>
      </div>
    </header>
    <div id="first-screen">
      <!--目前先用主页图片替代-->
      <img
        src="assets/award_title.png"
        alt="Momentum 中国人才势能大会 - 人工智能是人才招聘的新势能"
      />
    </div>
    <div id="brief">
      <div class="title gradient-bg">
        势能大奖
        <span>Introduction</span>
      </div>
      <div class="content">
        <p>
          仟寻作为中国社交招聘的开创者和人工智能招聘的领路人，服务了2020年《财富》世界500强中
          <b>近30%</b>的企业，在中国人力资源行业具有先锋影响力。
        </p>
        <p>
          中国人才势能大奖是仟寻为表彰行业内有杰出招聘表现的人力资源团队而设立的年度人力资源行业奖项，
          分设
          <b>移动社交招聘</b>、 <b>人工智能招聘</b>和
          <b>雇主品牌</b>三个子奖项。
          同时，仟寻携手美国高校驻华联盟(简称AUCA)联合发起
          <b>“2020最具留学生吸引力雇主”评选活动</b>， 揭晓了
          <b
            >2020最具留学生吸引力雇主TOP100榜单及各行业最具留学生吸引力雇主TOP5</b
          >， 旨在表彰雇主对海外留学归国人员就业的支持。
        </p>
      </div>
    </div>
    <!-- 势能大奖 3 x 10 -->
    <div class="award grid_1_3">
      <!-- 大奖类别（共3个） -->
      <div v-for="(award, index) in awards" :key="index">
        <div class="award-frame title">
          {{ award.title }}
          <a class="top10">Top 10</a>
        </div>
        <!-- 获奖者（每个奖10个） -->
        <div class="award-content">
          <div
            v-for="(winner, winner_index) in award.items"
            :key="winner_index"
          >
            <div class="logo-wrap">
              <img
                class="logo-img"
                :src="`/assets/awards/${award.img[winner_index]}`"
              />
            </div>
            <a>{{ winner.replace("有限公司", "") }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- AUCA 100 -->
    <div class="award">
      <div class="award-frame title">{{ auca.attractive.title }}</div>
      <!-- 获奖者 -->
      <div class="column_1_2">
        <div class="award-content border-right">
          <div class="center top-title">TOP 1-50</div>
          <div
            class="center"
            v-for="(winner, winner_index) in auca.attractive.items.slice(0, 50)"
            :key="winner_index"
          >
            <a>{{ winner.replace("有限公司", "") }}</a>
          </div>
        </div>
        <div class="award-content">
          <div class="center top-title">TOP 51-100</div>
          <div
            class="center"
            v-for="(winner, winner_index) in auca.attractive.items.slice(50)"
            :key="winner_index"
          >
            <a>{{ winner.replace("有限公司", "") }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- AUCA potential + tops -->
    <div class="award column_1_2">
      <!-- Potential + tops（共8个） -->
      <div v-for="(award, index) in rest" :key="index">
        <div class="award-frame minor-title">{{ award.title }}</div>
        <!-- 获奖者（每个奖5个） -->
        <div class="award-content">
          <div
            class="center"
            v-for="(winner, winner_index) in award.items"
            :key="winner_index"
          >
            <a>{{ winner.replace("有限公司", "") }}</a>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <span>© 2021 MoSeeker</span>
      <span id="icp">沪ICP证B2-20170397号</span>
    </footer>
  </div>
</template>
<script>
import auca from "@/data/auca.json";
import awards from "@/data/awards.json";

// Data format
//
// interface Award {
//   title: String
//   items: (Award | String)[]
// }

// rest: Award[]
const rest = [auca.potential];
rest.push(
  ...auca.tops.items.map((e) => {
    return {
      title: auca.tops.title + e.title,
      ...e,
    };
  })
);

console.log(rest);

export default {
  wx() {
    return [
      {
        name: "share",
        option: {
          link: window.location.href,
          title: document.title,
          imgUrl:
            "https://www.moseeker.com/theme/static/img/moats_logo_share.png",
          desc: "人工智能是人才招聘的新势能",
        },
      },
    ];
  },
  data: function() {
    return {
      awards,
      auca,
      rest,
    };
  },
  mounted() {
    // start wx share.
    this.$emit("vuewx:show");
  },
};
</script>
<style lang="less">
@import "@/css/global.less";
#first-screen {
  margin-bottom: 0;
}
.column_1_2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-template-columns: ~"repeat(auto-fit, minmax(max(400px,40%), 1fr))";
}
.award {
  gap: 2em;
  padding: 1em 2px;

  .title {
    color: white;
    font-size: 1.5em !important;
    height: auto !important;
    position: relative;

    .top10 {
      // position: relative;
      // font-size: 20px;
    }
  }
  .minor-title {
    color: white;
    font-size: 1.2em !important;
    height: auto !important;
    margin-bottom: 1.5rem;
  }
  .top-title {
    font-family: rosella-deco, "Times New Romen", Serif;
    display: inline-block;
    background-color: #2987e6;
    background-image: linear-gradient(
      90deg,
      #a574ff 10%,
      #2391ff 50%,
      #a574ff 90%
    );
    background-size: 100%;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    margin-bottom: 2rem !important;
    font-size: 2.3em !important;
  }
  .award-frame {
    .frame;
    padding: 0.7em;
  }
  .award-content {
    & > div {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      // word-break: keep-all;
      // height: 2rem;
      .logo-wrap {
        margin-right: 1rem;
        background: #fff;
        height: 3rem;
        width: 3rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding: 0.1rem;
        img {
          max-width: 2rem;
        }
      }
      &.center {
        justify-content: center;
      }
    }
  }
}

@media screen {
  @media (max-width: 650px) {
    #guide a {
      padding: 0.1em 0.8em !important;
      font-size: min(calc(0.6em + 0.25vw), 0.8em) !important;
    }
  }

  @media (max-width: 850px) {
    .grid_1_3 {
      display: flex;
      flex-direction: column;
      // div {
      //   padding: .3rem 1rem;
      // }
    }
  }

  @media (min-width: 851px) {
    .grid_1_3 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
    .award-content {
      padding-left: 1rem;
    }
    .border-right {
      border-right: solid 1px @blue;
    }
  }
}
</style>
